// GitHub-flavoured markdown that loads its parser (~50 kB gzip) only when some markdown is actually shown,
// instead of with every page that can open a panel containing markdown. The raw text shows meanwhile.
import { lazy, Suspense } from 'react'

const GfmMarkdown = lazy(() => import('./GfmMarkdown'))

export function LazyMarkdown({ children }: { children: string }) {
  return (
    <Suspense fallback={<p className="whitespace-pre-wrap">{children}</p>}>
      <GfmMarkdown>{children}</GfmMarkdown>
    </Suspense>
  )
}
